import CreatePurchaseOrder from './CreatePurchaseOrderContainer';

export default CreatePurchaseOrder;
